import React from 'react';
import './styles.css';
import { useHistory } from 'react-router';
import { Button, Col, Row } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useAuth } from '@BUP/hooks';
import { BupImageData, PageLayout } from '@BUP/components';

const DataDesertSurveyPage = () => {
  const history = useHistory();
  const { user } = useAuth();

  return (
    <PageLayout>
      <Row>
        <Col span={24} className="col-button" align="start">
          <Button
            type="text"
            className="button-back"
            onClick={() => history.push('/data')}
          >
            <ArrowLeftOutlined />
            Volver a DATA
          </Button>
        </Col>
      </Row>

      <Row className="desertSurvey_text-container">
        <Col>
          <p className="desertSurvey_text">
            Estimado/a {user.name}, la opinión de toda la comunidad es
            fundamental para mejorar la convivencia escolar. Si te arrepientes y
            quisieras volver a responder, te invitamos a hacer click en el
            diagnóstico y participar!
          </p>

          <p className="desertSurvey_text">¡Que tengas un buen día!</p>
        </Col>
      </Row>

      <BupImageData />
    </PageLayout>
  );
};

export default DataDesertSurveyPage;
